'use client'

import { ReactNode } from 'react'

import { cn } from '@/app/utils/style'
import { Language } from '@/lang'

interface GuideSidebarProps {
  className?: string
  children?: ReactNode
  language?: Language
}

export const GuideSidebar = ({ className, children, language }: GuideSidebarProps) => {
  return (
    <aside
      className={cn(
        'hidden w-[310px] flex-shrink-0 flex-grow-0 self-start sticky top-[calc(66px+theme(spacing.5xl))] xl:block',
        className,
      )}
    >
      <div className="flex flex-col gap-xl">{children}</div>
    </aside>
  )
}
